<template>
    <div class="board-container">
        <ul class="tab-list tab-list--tooth">
            <li :class="{ 'on': filter.type == '회원서비스' }"><a class="button" @click="filter.type='회원서비스'; search();">회원서비스</a></li>
            <li :class="{ 'on': filter.type == '상품' }"><a class="button" @click="filter.type='상품'; search();">상품</a></li>
            <li :class="{ 'on': filter.type == '배송' }"><a class="button" @click="filter.type='배송'; search()">배송</a></li>
            <li :class="{ 'on': filter.type == '교환/반품' }"><a class="button" @click="filter.type='교환/반품'; search();">교환/반품</a></li>
            <li :class="{ 'on': filter.type == '입금/결제' }"><a class="button" @click="filter.type='입금/결제'; search();">입금/결제</a></li>
            <li :class="{ 'on': filter.type == '기타' }"><a class="button" @click="filter.type='기타'; search();">기타</a></li>
        </ul>
        <div role="table" class="board-table board-table--faq">
            <div v-for="faq in faqs" role="rowgroup" :key="faq._id">
                <div role="row" class="question" data-idx="1" :data-answer="faq.opened ? 'opened' : 'closed'" @click="faqs.forEach((item) => $set(item, 'opened', item == faq ? !faq.opened : false));">
                    <div role="cell">
                        <div class="title"><a role="button"><i class="icon">Q</i>{{ faq.subject }}</a></div>
                    </div>
                </div>
                <div role="row" class="answer" data-idx-answer="1">
                    <div role="cell">
                        <div class="answer">
                            <div class="title"><i class="icon">A</i>자주 묻는 질문에 대한 답입니다.</div>
                            <p class="pr" v-html="faq.content.replace(/\n/g,'<br>')"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";

export default{
    props: {
        code: { type: String, default: null },
    },
    data() {
        return {
            filter: {
                type: "회원서비스",
            },
            faqs: []
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            try{
                await this.search();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async search(){
            try{
                var { summary, faqs } = await api.v1.center.faqs.getFaqs({
                    params: this.filter
                });

                this.faqs = faqs;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        }
    }
}
</script>
